// reducer.js
import * as types from "../actionTypes";

const initialState = {
  data: [],
  isLoading: false,
  message: "",
  status:false
};

const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_LOCATIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case types.FETCH_LOCATIONS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload.data,
        status: action.payload.status,
      };
    case types.FETCH_LOCATIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        data: [],
        message: action.payload.message,
        status: action.payload.status,
      };
    default:
      return state;
  }
};

export default locationReducer;
